export const ADMINISTRATIVE_CONFIG_PATH = '/administrative-config';
